import React from 'react'
import ExampleBoxes from './ExampleBoxes/ExampleBoxes'
import styles from './styles.module.css'

function ExampleSearches () {
  return (
    <section className={styles.ExampleSearches}>
      <div className={styles.ExampleSearchesHeader}>
        <h1 className={styles.ExampleSearchesTitle}>Example searches</h1>
        <p className={styles.ExampleSearchesDescription}>
          Select one of the options below to load in the given search
          parameters.
        </p>
      </div>
      <ExampleBoxes />
    </section>
  )
}

export default ExampleSearches
